import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import PremiumBenefits from 'app/frontend/base/pages/GuildDashboard/components/PremiumBenefits'

const TeamPremium = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Premium | ${team.name} | ${guild.name}`}>
      <h2>Premium</h2>
      <PremiumBenefits
        guild={guild}
        legacyTier={guild.legacyPatron?.details?.pledge_tier}
        benefits={guild.premiumBenefits || []}
      />
    </Section>
  )
}

export default TeamPremium
